export const SortingTypes = [
  // "Best Sellers",
  "Price (low to high)",
  "Price (high to low)",
];

export const QUIZ_TYPE = "skincare";
export const HEADER_TEXT = "Skincare Quiz";
export const RECOMMENDED_TEXT = "Here's what we recommend.";
export const START_OVER = "Start Over";
export const SORT_BY = "Sort by:";
export const RESULTS = "Results";
export const FILTER = "Filter";
export const VIEW_DETAILS = "View Details";
export const PRICE_RANGE = "Price Range";
export const RATING = "Rating";
export const GO_BUTTON = "Go";
export const BACK_BUTTON = "Back";
export const SELECT_ALL_THAT_APPLY_TITLE = "Select all that apply";
export const MIN_LABEL = "min";
export const MAX_LABEL = "max";
export const SKIP_NEXT_BUTTON = "Skip/Next";
export const BASED_ON_CONCERN_BUTTON = "Based on my concerns";
export const BASED_ON_PRODUCT_BUTTON = "Based on products I want";
export const HOME_SCREEN_QUESTION = "How do you want to shop for skincare?";

export const HOME_PAGE_TITLE_TEXT =
  "Skincare is personal. Answer a few questions, and we'll recommend products right for you. Every answer gets you one step closer to your perfect routine.";
export const NO_RESULT_FOUND_TEXT =
  "There are no products available that match your criteria. Try adjusting the filters.";
export const DISCLAIMER_TEXT = "Disclaimer: The product recommendations should not be considered medical advice. For additional questions about the skin concerns identified, please contact your healthcare provider."
